
<template>
  <v-list v-if="model && object"
          class="py-0"
          :dense="dense">
    <template v-for="field in model.fields">
      <v-container v-if="Array.isArray(field)"
                   :key="field.label"
                   class="pa-0">
        <v-row no-gutters>
          <v-col v-for="subfield in field"
                 :key="subfield.valuekey"
                 :cols="subfield.cols"
                 class="pa-0">
            <component v-if="subfield.editable != 'onlyedit'"
                       :is="parseFieldType(subfield.type)"
                       :label="subfield.label"
                       :value="getValueFromKey(subfield.valuekey)"
                       :keyname="subfield.valuekey"
                       :noempty="subfield.rules && subfield.rules.includes('noempty')"
                       :noname="subfield.rules && subfield.rules.includes('noname')"
                       :loading="loading"
                       @fetch="passupdate" />
          </v-col>
        </v-row>
      </v-container>
      <component v-else-if="field.editable != 'onlyedit'"
                 :key="field.label"
                 :is="parseFieldType(field.type)"
                 :label="field.label"
                 :value="getValueFromKey(field.valuekey)"
                 :keyname="field.valuekey"
                 :noempty="field.rules && field.rules.includes('noempty')"
                 :noname="field.rules && field.rules.includes('noname')"
                 :loading="loading"
                 @fetch="passupdate" />
    </template>
  </v-list>
</template>


<script>
import EditLi from "@/components/Inputs/EditableListItem.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
import AddressLi from "@/components/Inputs/AdressListItem.vue";
import AreaLi from "@/components/Inputs/AreaListItem.vue";
import DateLi from "@/components/Inputs/DateListItem.vue";
import TimeLi from "@/components/Inputs/TimeListItem.vue";
import UserList from "@/components/SingleUse/UserListListItem.vue";

export default {
  name: "ModelParser",
  props: ["model", "object", "dense", "loading"],
  components: { EditLi, SwitchLi, AddressLi, AreaLi, TimeLi },

  data: () => ({}),

  mounted() {  },

  methods: {
    passupdate(update) {
      this.$emit("fetch", update);
    },

    parseFieldType(type) {
      if (type === "switch") {
        return SwitchLi;
      } else if (type === "address") {
        return AddressLi;
      } else if (type === "area") {
        return AreaLi;
      } else if (type === "date") {
        return DateLi;
      } else if (type === "time") {
        return TimeLi;
      } else if (type === "userlist") {
        return UserList;
      } else {
        return EditLi;
      }
    },

    getValueFromKey(keychain) {
      var x = this.object;
      const keys = keychain.split(".");
      var returnValue = keys.reduce(function (reducedObject, potentialKey) {
        const keyValue = reducedObject ? reducedObject[potentialKey] : undefined;
        return keyValue;
      }, x || self);
      return returnValue;
    },
  },

  computed: {},

  watch: {},
};
</script>

